import ShieldIcon from '@mui/icons-material/Shield';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Tooltip } from '@mui/material';

interface AuditIconProps {
  hasAuditLog: boolean;
}

const AuditIcon = ({ hasAuditLog }: AuditIconProps) => {
  if (hasAuditLog) {
    return (
      <Tooltip title="Auditoria registrada">
        <ShieldIcon sx={{ color: '#4CAF50' }} />
      </Tooltip>
    );
  }

  return (
    <Tooltip title="Sem registro de auditoria">
      <WarningAmberIcon sx={{ color: '#FFC107' }} />
    </Tooltip>
  );
};

export default AuditIcon;
